// src/components/CeoSection.js (CORREGIDO)

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CeoSection.css'; 
import ceoPhoto from '../assets/images/ceo/GiovanniScarvaci.png'; 

const CeoSection = () => {
    const navigate = useNavigate(); // Inicialización

    return (
        <section id="ceo-summary" className="section ceo-summary-container">
            
            <div className="ceo-summary-content">
                
                <div className="ceo-summary-image-box">
                    <img src={ceoPhoto} alt="Foto de Giovanni Scarvaci" className="ceo-summary-photo" />
                </div>
                
                <div className="ceo-summary-text">
                    <h2>Conoce a Nuestro CEO</h2>
                    <h3>Abogado, Economista, Perito Avaluador</h3>
                    
                    <p>
                        **Giovanni Scarvaci** es un profesional destacado con más de 30 años de experiencia liderando soluciones estratégicas en Derecho Mercantil, Economia, Finanzas y Avalúos Periciales, garantizando probidad, lealtad y conocimiento.
                    </p>
                    
                    {/* 🚀 CORRECCIÓN: Se cambia '/ceo-page' a '/nuestro-ceo' para coincidir con App.js */}
                    <button 
                        className="cta-button primary" 
                        onClick={() => navigate('/nuestro-ceo')}
                    >
                        Ver Perfil Completo
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CeoSection;